<template>
  <Tabs :isRTL="isRTL" syncRoute>
    <Tab :label="$t('shifts')" :to="'/shift'" exact class="shift-holiday">
      <Loading class="loader" style="width:100%" v-show="!siteDetails || !mountedCmps.shift || !mountedCmps.holiday"/>
      <ShiftList
        shiftParentType="shift"
        :siteId="+siteId"
        :companyId="+companyId"
        :companyName="siteDetails.company_name"
        @loaded="mountedCmps.shift = true"
        v-show="siteDetails && mountedCmps.shift && mountedCmps.holiday"
        v-if="siteDetails"
      />
      <HolidayList
        shiftParentType="shift"
        :siteId="+siteId"
        :companyId="+companyId"
        :companyName="siteDetails.company_name"
        :companyCountry="siteDetails.country"
        :shifts="siteDetails.shifts"
        @loaded="mountedCmps.holiday = true"
        v-show="siteDetails && mountedCmps.shift && mountedCmps.holiday"
        v-if="siteDetails"
      />
    </Tab>
  </Tabs>
</template>

<script>
import ShiftList from '@/modules/control-panel/components/ShiftList'
import HolidayList from '@/modules/control-panel/components/HolidayList'
import Tabs from '../../common/components/Tabs/Tabs.vue'
import Tab from '../../common/components/Tabs/Tab.vue'
import Loading from '../../common/components/Loading.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'shift',
  data() {
    return {
      siteDetails: this.currentSiteInfo,
      mountedCmps: {
        shift: false,
        holiday: false,
      },
    }
  },
  components: {
    ShiftList,
    HolidayList,
    Loading,
    Tabs,
    Tab,
  },
  computed: {
    ...mapGetters(['isRTL', 'loggedUser', 'filterSelected', 'currentSiteInfo']),
    siteId() {
      const { id } = this.currentSiteInfo
      return id
    },
    companyId() {
      const { company_id: companyId } = this.currentSiteInfo
      return companyId
    },
  },
  watch: {
    currentSiteInfo: {
      async handler() {
        this.mountedCmps = {
          shift: false,
          holiday: false,
        }
        this.siteDetails = this.currentSiteInfo
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss">
.view-nav-container {
  height: 89vh;
  max-height: 89vh;
}

.shift-holiday {
  display: flex;
  flex-direction: row;
  height: 100%;
}

#app:has(.shift-holiday) .md-tabs {
  height: 100% !important;

  > * {
    display: flex;
    height: 100% !important;
  }

  > :first-child {
    height: fit-content !important;
  }

  > :nth-child(2) > * {
    height: 100%;
    width: 100%;
  }
}
</style>
